import Text from "common/Typography/Text.tsx";
import React from "react";
import Flex from "common/Boxes/Flex.tsx";
import Link from "common/Typography/Link.tsx";
import { TimePicker } from "antd";
import styled from "styled-components";
import EditOutlined from "@ant-design/icons/EditOutlined";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import useDisableWeekHours from "features/bots/BotForm/OperationHours/hooks/useDisableWeekHours.ts";
import { TIME_FORMAT } from "common/Calendars/constants.ts";

const DisableWeekHours = () => {
  const {
    disabledHours,
    setWeekHours,
    onRemoveClick,
    onEditClick,
    showNewRow,
    setShowNewRow,
    timePickerProps,
    setTimeRange,
  } = useDisableWeekHours();

  const getEditRow = (index?: number) => {
    return (
      <TimePicker.RangePicker
        onCalendarChange={(dates) => setTimeRange(dates)}
        onChange={() => setWeekHours(index)}
        style={{ width: "100%", marginTop: 12 }}
        value={index !== undefined ? disabledHours[index].value : undefined}
        {...timePickerProps}
      />
    );
  };

  const getNewTimePickerRow = () => {
    return (
      <Flex $alignItems="baseline">
        <NumRow>{disabledHours.length + 1}</NumRow>
        {getEditRow()}
      </Flex>
    );
  };

  const displayedHours = (
    <ListWrapper>
      {disabledHours.map((item, index) => {
        return (
          <Flex key={index}>
            <RowWrapper>
              <NumRow>{index + 1}</NumRow>
              {item.isEdit ? (
                getEditRow(index)
              ) : (
                <Flex>
                  <Text>
                    {item.value[0]?.format(TIME_FORMAT)} -{" "}
                    {item.value[1]?.format(TIME_FORMAT)}
                  </Text>
                  <EditIcon onClick={() => onEditClick(index)} />
                </Flex>
              )}
            </RowWrapper>
            {!item.isEdit && <CloseIcon onClick={() => onRemoveClick(index)} />}
          </Flex>
        );
      })}
    </ListWrapper>
  );

  return (
    <>
      <Flex style={{ marginBottom: 12 }}>
        <Text>Disable Week Hours</Text>
        <Link onClick={() => setShowNewRow(true)}>+ Add</Link>
      </Flex>
      {displayedHours}
      {showNewRow && getNewTimePickerRow()}
    </>
  );
};

export default DisableWeekHours;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;
const RowWrapper = styled(Flex)`
  width: 100%;
  align-items: baseline;
  justify-content: flex-start;
`;
const NumRow = styled(Flex)`
  color: ${(p) => p.theme.colors.secondaryGrey};
  border: ${(p) => p.theme.borders.medium};
  border-radius: 50px;
  min-width: 24px;
  min-height: 24px;
  justify-content: center;
  margin-right: 12px;
`;
const EditIcon = styled(EditOutlined)`
  color: ${(p) => p.theme.colors.primaryBlue};
  font-size: 18px;
  margin-left: 8px;
`;
const CloseIcon = styled(CloseOutlined)`
  color: ${(p) => p.theme.colors.primaryGrey};
`;
